import { RepositoryFactory } from '@/api/RepositoryFactory'

import { SEND_FORM, SET_LOADING } from '@/store/actions/reportForwarder'

const documentAPI = RepositoryFactory.get('doc')

export default {
  namespaced: true,
  state: {
    loading: false,
  },
  getters: {
    getLoading: state => state.loading,
  },
  actions: {
    [SEND_FORM]: ({ commit }, payment) => {
      commit(SET_LOADING, true)

      return documentAPI
        .getReportForwarder(payment.dateFrom, payment.dateTo)
        .then(response => response)
        .finally(() => commit(SET_LOADING, false))
    },
  },
  mutations: {
    [SET_LOADING]: (state, payload) => (state.loading = payload),
  },
}
